import { TriggerTypeApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeTriggerTypes } from './normalizers';
import { TriggerType } from './types';

export class VoladeumTriggerTypes extends Axios {
  async list(): Promise<VoladeumResponse<TriggerType[]>> {
    const res = await this.get<VoladeumResponse<TriggerTypeApi[]>>('/v1/lookups/trigger-types');
    return {
      success: res.success,
      error: res.error,
      data: normalizeTriggerTypes(res.data),
    };
  }
}
